import React, { useEffect, useState } from "react"
import { Row, Col } from "react-bootstrap"
import ExamPaperCard from "./ExamPaperCard"
import ExamPaperFooter from "./ExamPaperFooter"

import { FaRegBookmark, FaBookmark } from "react-icons/fa"

function AllComponent({
  selectedPapers,
  setSelectedPapers,
  questions,
  allBookmarkedIds,
  handleBookmarkClick,
  handleQuestionClick, // Accept as prop
  setShowModal, // Accept as prop
  setSelectedQuestion, // Accept as prop
  setQuestionDetailLoading, // Accept as prop
}) {
  const togglePaperSelection = (id, isSelected) => {
    setSelectedPapers((prev) =>
      isSelected ? [...prev, id] : prev.filter((paperId) => paperId !== id)
    )
  }

  return (
    <>
      <Row className='filter-content'>
        {questions.map((question, index) => {
          const isBookmarked = allBookmarkedIds.has(question._id)
          return (
            <Col key={question._id} xl={12} xxl={6} className='mb-4'>
              <div
              // onClick={() => handleQuestionClick(question)}
              >
                <ExamPaperCard
                  id={question._id}
                  title={`Q. ${question.question_number} ${question.part}`}
                  onCheckboxChange={(isSelected) =>
                    togglePaperSelection(question._id, isSelected)
                  }
                  isChecked={selectedPapers.includes(question._id)}
                  key={
                    question._id +
                    (isBookmarked ? "-bookmarked" : "-not-bookmarked")
                  }
                  bookMarkIconBtn={
                    isBookmarked ? <FaBookmark /> : <FaRegBookmark />
                  }
                  onBookmarkClick={(e) =>
                    handleBookmarkClick(e, question, isBookmarked)
                  }
                  onBodyClick={() => handleQuestionClick(question)}
                  bodyContent={
                    <img
                      src={question.question_file}
                      alt={`Question ${question.question_number}`}
                      style={{
                        width: "auto",
                        maxWidth: "100%",
                        height: "auto",
                        objectFit: "contain",
                        display: "block",
                      }}
                    />
                  }
                  footerContent={
                    <ExamPaperFooter
                      subject={question.topics[0]?.title}
                      paper={question.paper}
                      year={question.year}
                      markingSchemeContent={
                        <img
                          src={
                            question.ms_file ||
                            "https://placehold.co/600x400?text=No+image"
                          }
                          alt={`Question ${question.question_number}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                          onError={(e) => {
                            e.target.onerror = null
                            e.target.src =
                              "https://placehold.co/600x400?text=No+image"
                          }}
                        />
                      }
                    />
                  }
                />
              </div>
            </Col>
          )
        })}
      </Row>
    </>
  )
}

export default AllComponent
